const en = {
  title1: 'Overview of Blockchain Scams',
  article1: 'In the name of "blockchain" or using "blockchain" technology, scammers always scam users through lead them to take part in the high-yield financial project, Phishing activity, download fake decentralized wallet, and execute the “Approve” operation, etc.  All of these are SCAM!',
  title2: 'Security Topic Introduction',
  article2: 'TokenPocket is committed to the publicity and education of blockchain anti-fraud and anti-fraud, establishes fraud domain name reporting channels, and is committed to building a good blockchain network environment.',
  title3: 'Common ways of fraud',
  title4: 'Common Fraud Cases',
  title5: 'Security Measure',
  title6: 'More information',
  share: 'Share',
  copied: 'Copied',
  list1: [{
    title: 'Phishing App Scam',
    subtitle: 'The scammer will develop Apps that are highly similar to the official App. ',
    url: 'https://help.tokenpocket.pro/en/security-knowledge/common-fraud-cases/phishing-app-scam',
    pic: require('../../assets/1.png')
  }, {
    title: 'Beware of the Fishing SCAM!',
    subtitle: 'Private Key or Keystore and the admin will never contact you privately!',
    url: 'https://theodore-ratliff.gitbook.io/share/EN/security/swindle',
    pic: require('../../assets/2.png')
  }, {
    title: 'DApp Approval Scam',
    subtitle: 'When it comes to currency exchange in the DEX platform, the approval step will be used.',
    url: 'https://help.tokenpocket.pro/en/security-knowledge/common-fraud-cases/dapp-approval-scam',
    pic: require('../../assets/3.png')
  }, {
    title: 'Be aware of the call smart contract SCAM!',
    subtitle: 'A new type of fraud.',
    url: 'https://theodore-ratliff.gitbook.io/share/EN/security/call',
    pic: require('../../assets/4.png')
  }],
  list2: [{
    title: 'Phishing wallet scam on TRON chain',
    subtitle: 'This kind of scam to cheat gas fees is a relatively early one. ',
    url: 'https://theodore-ratliff.gitbook.io/share/EN/security/phishing',
    pic: require('../../assets/5.png')
  }, {
    title: 'How to prevent malicious approval',
    subtitle: 'Approve is a familiar calling method in our daily operations on the blockchain.',
    url: 'https://theodore-ratliff.gitbook.io/share/EN/security/malicious',
    pic: require('../../assets/6.png')
  }, {
    title: 'Be wary of new ways of stealing tokens',
    subtitle: 'There ain\'t no such thing as a free lunch.',
    url: 'https://theodore-ratliff.gitbook.io/share/EN/security/new',
    pic: require('../../assets/7.png')
  }, {
    title: 'Quick identification of scammers\' scams',
    subtitle: 'Several common types of blockchain scams.',
    url: 'https://theodore-ratliff.gitbook.io/share/EN/security/blockchain',
    pic: require('../../assets/8.png')
  }],
  list3: [{
    title: 'How to verify whether the wallet is genuine',
    subtitle: 'A must-read for newcomers.',
    url: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/verify',
    pic: require('../../assets/9.png')
  }, {
    title: 'About Approve',
    subtitle: 'What is an Approve?',
    url: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/about-approve',
    pic: require('../../assets/12.png')
  }, {
    title: 'How to check/cancel Approve?',
    subtitle: 'Combining theory and practice.',
    url: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/cancel-malicious-authorization',
    pic: require('../../assets/13.png')
  }, {
    title: 'Manage approval with Cointool',
    subtitle: 'TokenPocket operation tutorial.',
    url: 'https://theodore-ratliff.gitbook.io/share/EN/tutorial/cointool',
    pic: require('../../assets/14.png')
  }, {
    title: 'Loss Prevention',
    subtitle: 'It is important to back up the wallet and keep it properly.',
    url: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/loss-prevention',
    pic: require('../../assets/15.png')
  }, {
    title: 'Theft Prevention',
    subtitle: 'The root of anti-theft is the protection of private keys.',
    url: 'https://help.tokenpocket.pro/en/security-knowledge/security-measure/theft-prevention',
    pic: require('../../assets/16.png')
  }],
  moreList: [{
    title: '$1 billion has been lost in cryptocurrency scams since 2021, FTC warns',
    url: 'https://www.cnn.com/2022/06/04/business/cryptocurrency-scammers-ftc-warning/index.html'
  }, {
    title: 'Web3 Wallets Targeted by Chinese Hackers; “SeaFlower” Using Cloned Websites to Trick Crypto Traders',
    url: 'https://www.cpomagazine.com/cyber-security/web3-wallets-targeted-by-chinese-hackers-seaflower-using-cloned-websites-to-trick-crypto-traders/'
  }],
  warning: 'Articles in Blockchain 101 section cannot be regarded as investment advice or recommendation. Users are suggested to make investment decisions based on their own financial situation and risk-taking ability and do their own research in the project. Articles here do not represent TokenPocket’s investment advice. Investment involves risks and you are suggested to be aware of this and make investment decisions accordingly. '
};

export default en;
